import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SiteState, sitesFeatureKey, SiteMetric } from './site.reducers';

const ADD_RESIDENT_FOR_SITE = 'add_resident_for_site';
const VIEW_RESIDENT_FOR_SITE = 'view_resident_for_site';
const ADD_MESSAGESET_FOR_SITE = 'add_messageset_for_site';
const VIEW_MESSAGESET_FOR_SITE = 'view_messageset_for_site';
const ADD_ASSISTANCE_PROVIDER_FOR_SITE = 'add_assistanceprovider_for_site';
const CHANGE_ASSISTANCE_PROVIDER_FOR_SITE =
  'change_assistanceprovider_for_site';

// Selector functions
const getSiteFeatureState = createFeatureSelector<SiteState>(sitesFeatureKey);

export const selectSites = createSelector(
  getSiteFeatureState,
  (state) => state.sites
);

export const selectSite = (id: number) =>
  createSelector(getSiteFeatureState, (state) => {
    return state.sites.find((site) => site.id === id);
  });

export const selectSiteMetric = (id: number) =>
  createSelector(getSiteFeatureState, (state) => {
    return state.siteMetrics.find(
      (siteMetric: SiteMetric) => siteMetric.site_id === id
    );
  });

export const selectSiteNames = createSelector(getSiteFeatureState, (state) =>
  state.sites.map((site) => site.name)
);

export const selectSitePermissions = createSelector(
  getSiteFeatureState,
  (state) => state.permissions
);

export const selectHasAddResidentPermission = createSelector(
  getSiteFeatureState,
  (state) => {
    let hasPerm = false;
    for (let key in state.permissions) {
      if (state.permissions[key].includes(ADD_RESIDENT_FOR_SITE)) {
        hasPerm = true;
      }
    }
    return hasPerm;
  }
);

export const selectHasPermission = (id: number, permission: string) =>
  createSelector(getSiteFeatureState, (state) => {
    return state.permissions[id].includes(permission);
  });

export const selectSitesWithAddResidentPermissions = createSelector(
  getSiteFeatureState,
  (state) => {
    return state.sites.filter((site) =>
      state.permissions[site.id].includes(ADD_RESIDENT_FOR_SITE)
    );
  }
);

export const selectSitesWithViewResidentPermissions = createSelector(
  getSiteFeatureState,
  (state) => {
    return state.sites.filter((site) =>
      state.permissions[site.id].includes(VIEW_RESIDENT_FOR_SITE)
    );
  }
);

export const selectSitesWithViewMessageSetPermissions = createSelector(
  getSiteFeatureState,
  (state) => {
    return state.sites.filter((site) =>
      state.permissions[site.id].includes(VIEW_MESSAGESET_FOR_SITE)
    );
  }
);

export const selectSitesWithAddMessageSetPermissions = createSelector(
  getSiteFeatureState,
  (state) => {
    return state.sites.filter((site) =>
      state.permissions[site.id].includes(ADD_MESSAGESET_FOR_SITE)
    );
  }
);

export const selectSitesWithAddAssistanceProviderPermissions = createSelector(
  getSiteFeatureState,
  (state) => {
    return state.sites.filter((site) =>
      state.permissions[site.id].includes(ADD_ASSISTANCE_PROVIDER_FOR_SITE)
    );
  }
);

export const selectSitesWithChangeAssistanceProviderPermissions =
  createSelector(getSiteFeatureState, (state) => {
    return state.sites.filter((site) =>
      state.permissions[site.id].includes(CHANGE_ASSISTANCE_PROVIDER_FOR_SITE)
    );
  });
